export interface DebugTriggerOptions {
  onDebugTriggered: () => void;
  debugString?: string;
  touchTrigger?: boolean;
}

const TOUCH_TRIGGER_TOUCH_POINTS = 3;
const TOUCH_TRIGGER_DELAY_MS = 1000;

export default class DebugTrigger {
  private index = 0;
  private touchTimeout: number | undefined;

  private readonly onDebugTriggered: () => void;
  private readonly debugString: string;
  private readonly touchTrigger: boolean;

  constructor({
    onDebugTriggered,
    debugString = 'DEBUG',
    touchTrigger = false,
  }: DebugTriggerOptions) {
    this.onDebugTriggered = onDebugTriggered;
    this.debugString = debugString;
    this.touchTrigger = touchTrigger;
  }

  public init() {
    window.addEventListener('keypress', this.onKeypress);
    if (this.touchTrigger) {
      window.addEventListener('touchstart', this.onTouchstart);
      window.addEventListener('touchend', this.onTouchend);
    }
  }

  public close() {
    window.removeEventListener('keypress', this.onKeypress);
    if (this.touchTrigger) {
      window.removeEventListener('touchend', this.onTouchend);
      window.removeEventListener('touchstart', this.onTouchstart);
    }
  }

  onKeypress = (e: KeyboardEvent) => {
    if (e.defaultPrevented) {
      return;
    }

    if (e.key === this.debugString[this.index]) {
      this.index += 1;
      if (this.index === this.debugString.length) {
        this.onDebugTriggered();
        this.index = 0;
      }
    } else {
      this.index = 0;
    }
  };

  onTouchstart = (e: TouchEvent) => {
    this.updateTouchTriggerTimeout(e);
  };

  onTouchend = (e: TouchEvent) => {
    this.updateTouchTriggerTimeout(e);
  };

  private updateTouchTriggerTimeout(e: TouchEvent) {
    if (e.touches.length !== TOUCH_TRIGGER_TOUCH_POINTS) {
      window.clearTimeout(this.touchTimeout);
      this.touchTimeout = undefined;
      return;
    }
    if (!this.touchTimeout) {
      this.touchTimeout = window.setTimeout(() => {
        this.touchTimeout = undefined;
        this.onDebugTriggered();
      }, TOUCH_TRIGGER_DELAY_MS);
    }
  }
}
